import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { commonLabelConstants } from '../../constants/label-constants';

@Component({
  selector: 'app-no-access-page',
  templateUrl: './no-access-page.component.html',
  styleUrl: './no-access-page.component.scss'
})

export class NoAccessPageComponent {

  labelConstant: any;

  constructor(private readonly route: Router) { }

  ngOnInit(): void {
    this.labelConstant = commonLabelConstants;
  }

  goToLogin() {
    this.route.navigate(['/dashboard']);
  }
}